// Coefficienti di ammortamento per il calcolo avanzato — tabella semplificata
// per beni agevolabili dall'Iperammortamento 2026 (L. 199/2025) / Nuova Sabatini.
//
// Struttura: Gruppo -> Descrizione (bene) -> Aliquota di ammortamento.

export const COEFFICIENTI = [
  {
    gruppo: "Macchinari 4.0",
    beni: [
      { descrizione: "Macchine CNC", aliquota: 10 },
      { descrizione: "Robot industriali", aliquota: 10 },
      { descrizione: "Magazzini automatici", aliquota: 10 },
      { descrizione: "Linee produttive automatizzate", aliquota: 10 },
      { descrizione: "Sistemi di controllo qualità", aliquota: 10 },
    ],
  },
  {
    gruppo: "Attrezzature e mezzi",
    beni: [
      { descrizione: "Carrelli AGV/Muletti", aliquota: 20 },
    ],
  },
  {
    gruppo: "Hardware",
    beni: [
      { descrizione: "Server e hardware industriale", aliquota: 20 },
    ],
  },
  {
    gruppo: "Software",
    beni: [
      { descrizione: "Software ERP", aliquota: 20 },
      { descrizione: "Software MES", aliquota: 20 },
    ],
  },
  {
    gruppo: "Energia",
    beni: [
      { descrizione: "Impianto fotovoltaico", aliquota: 9 },
    ],
  },
];

// Helpers per il componente BeniBreakdown
export function listGruppi() {
  return COEFFICIENTI.map((g) => g.gruppo);
}

export function listBeni(gruppo) {
  const g = COEFFICIENTI.find((x) => x.gruppo === gruppo);
  return g ? g.beni : [];
}

export function findAliquota(gruppo, descrizione) {
  const beni = listBeni(gruppo);
  const b = beni.find((x) => x.descrizione === descrizione);
  return b ? b.aliquota : null;
}
